/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 14C9 15.1046 9.89543 16 11 16H13.2566C14.2194 16 15 15.2194 15 14.2566C15 13.5062 14.5198 12.8399 13.8079 12.6026L10.1921 11.3974C9.48019 11.1601 9 10.4938 9 9.74342C9 8.78055 9.78055 8 10.7434 8H13C14.1046 8 15 8.89543 15 10M12 6.5V17.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill="currentColor"
			/>
			<path
				d="M9 14C9 15.1046 9.89543 16 11 16H13.2566C14.2194 16 15 15.2194 15 14.2566C15 13.5062 14.5198 12.8399 13.8079 12.6026L10.1921 11.3974C9.48019 11.1601 9 10.4938 9 9.74342C9 8.78055 9.78055 8 10.7434 8H13C14.1046 8 15 8.89543 15 10M12 6.5V17.5M22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22V22C17.5228 22 22 17.5228 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12.7499 6.5C12.7499 6.08579 12.4141 5.75 11.9999 5.75C11.5857 5.75 11.2499 6.08579 11.2499 6.5V7.25H10.7433C9.36622 7.25 8.24988 8.36634 8.24988 9.74342C8.24988 10.8167 8.93664 11.7695 9.95481 12.1089L11.2499 12.5406V15.25H10.9999C10.3095 15.25 9.74988 14.6904 9.74988 14C9.74988 13.5858 9.41409 13.25 8.99988 13.25C8.58566 13.25 8.24988 13.5858 8.24988 14C8.24988 15.5188 9.48109 16.75 10.9999 16.75H11.2499V17.5C11.2499 17.9142 11.5857 18.25 11.9999 18.25C12.4141 18.25 12.7499 17.9142 12.7499 17.5V16.75H13.2565C14.6335 16.75 15.7499 15.6337 15.7499 14.2566C15.7499 13.1833 15.0631 12.2305 14.0449 11.8911L12.7499 11.4594V8.75H12.9999C13.6902 8.75 14.2499 9.30964 14.2499 10C14.2499 10.4142 14.5857 10.75 14.9999 10.75C15.4141 10.75 15.7499 10.4142 15.7499 10C15.7499 8.48122 14.5187 7.25 12.9999 7.25H12.7499V6.5ZM10.7433 8.75H11.2499V10.9594L10.4291 10.6859C10.0235 10.5506 9.74988 10.171 9.74988 9.74342C9.74988 9.19477 10.1946 8.75 10.7433 8.75ZM12.7499 15.25V13.0406L13.5706 13.3141C13.9763 13.4494 14.2499 13.829 14.2499 14.2566C14.2499 14.8052 13.8051 15.25 13.2565 15.25H12.7499Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 2.83209C14.7751 2.2969 13.4222 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.74835 21.2558 7.67051 20 5.99902M9 14C9 15.1046 9.89543 16 11 16H13.2566C14.2194 16 15 15.2194 15 14.2566C15 13.5062 14.5198 12.8399 13.8079 12.6026L10.1921 11.3974C9.48019 11.1601 9 10.4938 9 9.74342C9 8.78055 9.78055 8 10.7434 8H13C14.1046 8 15 8.89543 15 10M12 6.5V17.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 14C9 15.1046 9.89543 16 11 16H13.2566C14.2194 16 15 15.2194 15 14.2566C15 13.5062 14.5198 12.8399 13.8079 12.6026L10.1921 11.3974C9.48019 11.1601 9 10.4938 9 9.74342C9 8.78055 9.78055 8 10.7434 8H13C14.1046 8 15 8.89543 15 10M12 6.5V17.5M22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22V22C17.5228 22 22 17.5228 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 5.75C12.4142 5.75 12.75 6.08579 12.75 6.5V7.25H13C14.5188 7.25 15.75 8.48122 15.75 10C15.75 10.4142 15.4142 10.75 15 10.75C14.5858 10.75 14.25 10.4142 14.25 10C14.25 9.30964 13.6904 8.75 13 8.75H12.75V11.4594L14.0451 11.8911C15.0632 12.2305 15.75 13.1833 15.75 14.2566C15.75 15.6337 14.6337 16.75 13.2566 16.75H12.75V17.5C12.75 17.9142 12.4142 18.25 12 18.25C11.5858 18.25 11.25 17.9142 11.25 17.5V16.75H11C9.48122 16.75 8.25 15.5188 8.25 14C8.25 13.5858 8.58579 13.25 9 13.25C9.41421 13.25 9.75 13.5858 9.75 14C9.75 14.6904 10.3096 15.25 11 15.25H11.25V12.5406L9.95493 12.1089C8.93676 11.7695 8.25 10.8167 8.25 9.74342C8.25 8.36634 9.36634 7.25 10.7434 7.25H11.25V6.5C11.25 6.08579 11.5858 5.75 12 5.75ZM11.25 8.75H10.7434C10.1948 8.75 9.75 9.19477 9.75 9.74342C9.75 10.171 10.0236 10.5506 10.4293 10.6859L11.25 10.9594V8.75ZM12.75 13.0406V15.25H13.2566C13.8052 15.25 14.25 14.8052 14.25 14.2566C14.25 13.829 13.9764 13.4494 13.5707 13.3141L12.75 13.0406Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
